import { render } from "./PurchaseButtonFloat.vue?vue&type=template&id=b9b2a924&lang=pug"
import script from "./PurchaseButtonFloat.vue?vue&type=script&lang=js"
export * from "./PurchaseButtonFloat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__